<div class="casino-register-container text">
  <div class="sub-text-row">{{ 'casino_register_1' | translate }}</div>
  <form class="change-password-form" [formGroup]="casinoRegisterDatas">
    <div class="two-fields">
      <dropdownb3
        formControlName="Phonecodeid"
        [fID]="'Phonecodeid'"
        fErrorText="{{ 'register_phone_number_optional' | translate }}"
        fPlaceholder="{{ 'Phone_Code' | translate }}"
        [fData]="this.PhoneNumberList"
        [fDataValueKey]="'PhoneCodeId'"
        [fDataViewKey]="'PhoneCode'"></dropdownb3>
      <inputBase
        fInputType="number"
        formControlName="PhoneNumber"
        fErrorText="{{ 'register_phone_number_optional' | translate }}"
        fPlaceholder="{{ 'register_phone_number_optional' | translate }}"></inputBase>
    </div>
    <inputBase
      [disabled]="EmailDisabled"
      formControlName="eMail"
      extraClass="profileInputs"
      fErrorText="{{ 'Required' | translate }}"
      fPlaceholder="{{ 'Email' | translate }}"
      fInputType="email"></inputBase>
    <inputBase
      [disabled]="BirthPlaceCityDisabled"
      formControlName="birthPlace"
      extraClass="profileInputs"
      fErrorText="{{ 'Required' | translate }}"
      fPlaceholder="{{ 'bplace' | translate }}"
      fInputType="text">
    </inputBase>
    <inputBase
      [disabled]="BirthplaceCountryDisabled"
      formControlName="country"
      extraClass="profileInputs"
      fErrorText="{{ 'Required' | translate }}"
      fPlaceholder="{{ 'Country' | translate }}"
      fInputType="text"></inputBase>
  </form>

  <ng-container *ngIf="casinoRegisterDatas.valid; else noValid">
    <div class="btn mobile colored green" (click)="saveCasinoRegister()">
      <div class="btn-text mobile-text-white">
        {{ 'Confirm' | translate }}
      </div>
    </div>
  </ng-container>
  <ng-template #noValid>
    <div class="btn mobile colored green" style="opacity: 0.5">
      <div class="btn-text mobile-text-white">
        {{ 'Confirm' | translate }}
      </div>
    </div>
  </ng-template>
</div>
